import { render, staticRenderFns } from "./member-price.vue?vue&type=template&id=13810064&"
import script from "./member-price.vue?vue&type=script&lang=js&"
export * from "./member-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports